<template>
  <div :class="classes">
      <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 50, 200]"
      :page-size="pageSize" isOutside
      ref="table" :current-page="currentPage">
      <wt-table :labels="tableLabel" :list="tableData">
        <el-table-column label="原商城订单">
          <template slot-scope="scope">
            <router-link  :class="$style['get-order-detail']" :to ="`/mall-order-all/order-detail/${scope.row.mallOrderId}/detail`">
              {{scope.row.mallOrderId}}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column label="原样本条码号">
          <template slot-scope="scope">
              {{scope.row.previousSampleId}}
          </template>
        </el-table-column>
          <slot/>
      </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-sample-recollect-table'

export default {
  name: 'pt-sample-recollect-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    isOutside: {
      type: Boolean,
      default: false
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 0
    },
    tableLabel: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next, size) {
      this.$emit('getTableData', page, next, size)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.get-order-detail{
  color: #edbe81;
}
</style>
